import { cn } from "@/lib/utils";

interface MainContainerProps {
  children: React.ReactNode;
  isMobileOnly?: boolean;
  isDesktopOnly?: boolean;
  classNames?: string;
}

export function MainContainer({
  children,
  isMobileOnly,
  isDesktopOnly,
  classNames,
}: MainContainerProps) {
  return (
    <main
      className={cn(
        "relative h-[100dvh] w-full overflow-y-auto bg-nt-neutral-50 bg-[url(/resources/background-mobile.svg)] bg-cover bg-center bg-no-repeat md:bg-[url(/resources/background-desktop.svg)]",
        isMobileOnly && "lg:hidden",
        isDesktopOnly && "hidden lg:block",
        classNames
      )}>
      {children}
    </main>
  );
}
